/* Wolki Farm — Meat Box PDP image gallery.
   The meat-box mega-section shows ONE hardcoded image in the buy box (.mb-frame).
   This turns it into a swipeable carousel of the product's full media (photos +
   comparison cards) by fetching /products/{handle}.js — no per-product config.
   Hosted on Shopify Files CDN; loaded by one <script> tag in sections/meat-box.liquid. */
(function () {
  'use strict';
  var CSS =
    '.mb-buy__media .mb-frame[data-mbg]{position:relative;overflow:hidden;padding:0}' +
    '.mbg-track{display:flex;overflow-x:auto;scroll-snap-type:x mandatory;scroll-behavior:smooth;scrollbar-width:none;-webkit-overflow-scrolling:touch}' +
    '.mbg-track::-webkit-scrollbar{display:none}' +
    '.mbg-slide{flex:0 0 100%;scroll-snap-align:start}' +
    '.mbg-slide img{width:100%;display:block}' +
    '.mbg-nav{position:absolute;top:50%;transform:translateY(-50%);z-index:3;width:38px;height:38px;border-radius:50%!important;background:rgba(255,255,255,.92)!important;border:0!important;cursor:pointer;font:700 22px/1 Arial,sans-serif!important;color:#111!important;display:flex!important;align-items:center;justify-content:center;box-shadow:0 2px 8px rgba(0,0,0,.2);padding:0!important;min-height:0!important;min-width:0!important}' +
    '.mbg-nav::before,.mbg-nav::after{content:none!important;display:none!important}' +
    '.mbg-prev{left:10px}.mbg-next{right:10px}' +
    '.mbg-dots{position:absolute;bottom:12px;left:0;right:0;display:flex;justify-content:center;gap:7px;z-index:3}' +
    '.mbg-dot{width:9px;height:9px;border-radius:50%!important;background:rgba(255,255,255,.7)!important;border:1px solid rgba(0,0,0,.25)!important;cursor:pointer;padding:0!important;min-height:0!important;min-width:0!important}' +
    '.mbg-dot::before,.mbg-dot::after{content:none!important;display:none!important}' +
    '.mbg-dot.on{background:#e8470a!important}';
  function injectCss() { if (document.getElementById('mbg-css')) return; var s = document.createElement('style'); s.id = 'mbg-css'; s.textContent = CSS; document.head.appendChild(s); }
  function handle() {
    var el = document.getElementById('mb-data');
    if (el) { try { return JSON.parse(el.textContent).handle; } catch (e) {} }
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }
  function btn(cls, txt) { var b = document.createElement('button'); b.type = 'button'; b.className = cls; if (txt) b.textContent = txt; return b; }
  function build() {
    var frame = document.querySelector('.mb-buy__media .mb-frame');
    if (!frame || frame.dataset.mbg) return;
    var h = handle(); if (!h) return;
    fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var imgs = (p.media || []).filter(function (m) { return m.media_type === 'image'; }).map(function (m) { return m.src; });
        if (imgs.length < 2) return;
        frame.dataset.mbg = '1';
        injectCss();
        var track = document.createElement('div'); track.className = 'mbg-track';
        imgs.forEach(function (src, i) {
          var sl = document.createElement('div'); sl.className = 'mbg-slide';
          var im = document.createElement('img');
          im.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1000';
          im.loading = i ? 'lazy' : 'eager'; im.alt = p.title || '';
          sl.appendChild(im); track.appendChild(sl);
        });
        frame.innerHTML = ''; frame.appendChild(track);
        var prev = btn('mbg-nav mbg-prev', '‹'), next = btn('mbg-nav mbg-next', '›');
        frame.appendChild(prev); frame.appendChild(next);
        var dotsWrap = document.createElement('div'); dotsWrap.className = 'mbg-dots';
        var dots = imgs.map(function (_, i) { var d = btn('mbg-dot' + (i ? '' : ' on'), ''); d.setAttribute('data-i', i); dotsWrap.appendChild(d); return d; });
        frame.appendChild(dotsWrap);
        function go(i) { i = Math.max(0, Math.min(imgs.length - 1, i)); track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }); }
        function cur() { return Math.round(track.scrollLeft / track.clientWidth); }
        prev.onclick = function () { go(cur() - 1); };
        next.onclick = function () { go(cur() + 1); };
        dots.forEach(function (d) { d.onclick = function () { go(+d.getAttribute('data-i')); }; });
        track.addEventListener('scroll', function () { var c = cur(); dots.forEach(function (d, i) { d.classList.toggle('on', i === c); }); });
      })
      .catch(function () {});
  }
  if (document.readyState !== 'loading') build(); else document.addEventListener('DOMContentLoaded', build);
})();
